import moment from "moment";
import find from "lodash/find";

export const toolkitCategories = [
  {
    key: 1,
    name: "Diversity Calendar",
    link: "diversity-calendar",
    definition: "National and international observances",
    isEventType: true,
    isHidden:true
  },
  {
    key: 2,
    name: "Favorites",
    link: "favorites",
  },
  {
    key: 3,
    name: "All",
    link: "all",
  },
  {
    key: 4,
    name: "Best Practices",
    link: "best-practices",
    definition:
      "A process, approach or method that has proven effective in improving Diversity and Inclusion and workplace culture.",
  },
  {
    key: 5,
    name: "Associations",
    link: "associations",
    definition:
      "A group organized for the purpose of improving Diversity and Inclusion and workplace culture.",
  },
  {
    key: 6,
    name: "Conferences & Events",
    link: "conferences-events",
    definition:
      "A meeting, networking get together, speech, formal gathering of a group, panel, talk, or online forum which can contribute to improving Diversity and Inclusion and workplace culture.",
    isEventType: true,
  },
  // {
  //   key: 6,
  //   name: 'Consultants',
  //   link: 'consultants',
  //   definition: "An experienced and knowledgeable professional or firm who provides valuable advice, guidance, and support to an organization with intent of improving Diversity and Inclusion, and workplace culture."
  // },
  {
    key: 7,
    name: "Employee Groups",
    link: "ergs",
    definition:
      "A group of employees who join together in their workplace to improve Diversity and Inclusion and workplace culture through dialogue, policies and  initiatives, aligned with the organization's vision, mission, and objectives.",
  },
  {
    key: 8,
    name: "Policies & Benefits",
    link: "policies-benefits",
    definition:
      "Established set of rules of conduct and procedures within an organization that define the rights and responsibilities of both employees and employers, as well as benefits focused on improving Diversity & Inclusion.",
  },
  {
    key: 9,
    // name: 'Programs & Initiatives',
    name: "Programs & Initiatives",
    link: "programs-initiatives",
    definition:
      "An organization's prioritized activity or focused effort intended to improve Diversity and Inclusion and workplace culture.",
  },
  {
    key: 10,
    name: "Recruitment & Hiring",
    link: "recruitment-hiring",
    definition:
      "People, firms, events and online resources involved in attracting, shortlisting, interviewing, selecting and hiring suitable candidates for positions in the organization.",
  },
  {
    key: 11,
    name: "Training & Development",
    link: "training-development",
    definition:
      "Physical or on-line training, mentorship, or  coaching provided to develop employees and managers with intent of improving Diversity and Inclusion and workplace culture.",
  },
  {
    key: 12,
    name: "Workplace Culture",
    link: "workplace-culture",
    definition:
      "Employee feedback and communications tools which can improve Diversity and Inclusion and workplace culture.",
  },
  {
    key: 13,
    name: "Archive",
    link: "archive",
  },
];

export const analyticsCategories = [
  {
    key: 1,
    name: "Favorites",
    link: "favorites",
  },
  {
    key: 2,
    name: "All",
    link: "all",
  },
  {
    key: 3,
    name: "Business & Culture",
    link: "business",
    categoryCode: "BFI",
  },
  {
    key: 4,
    name: "Compensation",
    link: "compensation",
    categoryCode: "COMP",
  },
  {
    key: 5,
    name: "Growth & Development",
    link: "growth-development",
    categoryCode: "GRO",
  },
  {
    key: 6,
    name: "Hiring & Retention",
    link: "hiring-retention",
    categoryCode: "HRT",
  },
  {
    key: 7,
    name: "Processes & Policies",
    link: "processes-policies",
    categoryCode: "PRP",
  },
  {
    key: 8,
    name: "Representation",
    link: "representation",
    categoryCode: "REP",
  },
  {
    key: 9,
    name: "Archive",
    link: "archive",
  },
];

export const getToolkitCategories = () => {
  let addToolkitCategories = [...toolkitCategories];
  return addToolkitCategories.filter(
    category =>
      category.name !== "All" &&
      category.name !== "Archive" &&
      category.name !== "Favorites"
  );
  // return addToolkitCategories.map(category => category.name);
};

// export const addToolkitCategories = ["Association","Employee Groups", "Events",
// "Experts","Law & Regulations","Marketing Materials",
// "Policies & Handbooks","Program & Initiatives","Talent Sources",
// "Training",];

export const createChartCategories = [
  "Business & Culture",
  "Compensation",
  "Growth & Development",
  "Hiring & Retention",
  "Processes & Policies",
  "Representation",
];

export const initialToolDetailsState = {
  _id: undefined,
  name: "",
  category: "",
  bannerImg: "",
  subCategory: "",
  description: "",
  website: "",
  image: "",
  attachment: "",
  attachments: [],
  sponsersName: "",
  noOfMembers: "",
  startDate: "",
  endDate: "",
  selectedLocations: {
    countries: [],
    states: [],
  },
  diversityFocus: [],
  relevantFor: [],
  diversityFocusTags: "",
  relevantForTags: "",
  toolkitTags: "",
  address: "",
  contactName: "",
  contactEmailID: "",
  contactPhone: "",
  latitude: "",
  longitude: "",
  nextStep: "",
  ratings: [],
  privacy: "",
  permission: "",
  location:{
    type:"Point",
    coordinates:[]
  },
  eventAddress: "",
};

export const initialChartDetailsState = {
  _id: undefined,
  name: "",
  category: "",
  startDate: "",
  endDate: "",
  kpiType: "",
  genderType: "FEMALE",
  useLatestDataAvailable: false,
  privacy: "",
  permission: "",
  nextStep: "",
  isPrivacySettingsChanged: false,
  kpiRecords: [],
  selectedBenchmarkData: [],
  kpiAgreegateData: [],
  kpiBenchmarkData: [],
  benchmarkLocation: { country: null, state: null },
};

export const getAnalyticsNameById = id => {
  console.log(id);
  const category = find(analyticsCategories, { link: id });
  console.log(category);
  if (category !== undefined) {
    return category.name;
  }
};

export const getLocations = () => {
  let locations = [
    "Los Angeles",
    "New York",
    "Chicago",
    "San Diego",
    "San Jose",
    "San Francisco",
  ];
  return locations.map(location => {
    return { key: location, value: location };
  });
};

export const reportingCategories = [
  {
    key: 1,
    name: "Stories & Comments",
    link: "story-comment",
  },
];
